export const hardRedirectTo = (url: string, timer?: number): void => {
  setTimeout(() => {
    const loc = window.location
    window.location.assign(loc.protocol + '//' + loc.host + url || '/login')
  }, timer || 0)
}
